import React, { Component } from 'react';
import { ButtonGroup, Button } from 'ui';
import Table from 'components/shared/table';
import LinkButton from 'components/shared/LinkButton';
import request from 'utils/request_ajax';
import { routes } from '../../constants/config';

import SubscriptionForm from './SubscriptionForm';
import AlertBox, { Heading, SubHeading } from '../shared/AlertBox';

const newSubscription = {
  id: null,
  subscribed: false,
  url: '',
  token: '',
  version: 1,
  events: [],
};

const DeleteModal = ({ onDismiss, onSubmit }) => (
  <AlertBox onDismiss={onDismiss}>
    <Heading>
      {t('settings.tab.api_webhook.event_subscription.delete_susbcription')}
    </Heading>
    <SubHeading>
      {t('settings.tab.api_webhook.event_subscription.confirm_delete')}
    </SubHeading>
    <ButtonGroup alignEnd>
      <LinkButton
        type="primary"
        className="cancel mr-24 ml-24"
        onClick={onDismiss}
      >
        {t('common.cancel')}
      </LinkButton>
      <Button onClick={onSubmit} primary>
        {t('settings.tab.api_webhook.event_subscription.delete')}
      </Button>
    </ButtonGroup>
  </AlertBox>
);

const ErrorMessages = ({ errors, onDismiss }) => {
  const ErrorSection = ({ title, messages }) => (
    <div>
      <SubHeading>{title}</SubHeading>
      <ul>
        {messages.map(message => (
          <li key={message}>{message}</li>
        ))}
      </ul>
    </div>
  );

  return (
    <AlertBox onDismiss={onDismiss}>
      <Heading>{t('common.error')}</Heading>
      {Object.keys(errors).map(key => (
        <ErrorSection key={key} title={key} messages={errors[key]} />
      ))}
    </AlertBox>
  );
};

const SubscriptionsTable = ({
  subscriptions,
  editSubscription,
  setDeletableSubscriptionId,
  toggleDeleteModal,
}) => {
  return (
    <Table alternate>
      <Table.Body>
        {subscriptions.map(subscription => (
          <Table.Row key={subscription.id}>
            <Table.Body.Cell size="center">
              {subscription.subscribed
                ? t('settings.tab.api_webhook.event_subscription.subscribed')
                : t('settings.tab.api_webhook.event_subscription.unsubscribed')}
            </Table.Body.Cell>
            <Table.Body.Cell size="xl">{subscription.url}</Table.Body.Cell>
            <Table.Body.Cell size="center">
              <LinkButton
                type="primary"
                onClick={() => {
                  editSubscription(subscription);
                }}
              >
                {t('settings.tab.api_webhook.event_subscription.edit')}
              </LinkButton>
            </Table.Body.Cell>
            <Table.Body.Cell size="center">
              <LinkButton
                type="primary"
                onClick={() => {
                  toggleDeleteModal(true);
                  setDeletableSubscriptionId(subscription.id);
                }}
              >
                {t('settings.tab.api_webhook.event_subscription.delete')}
              </LinkButton>
            </Table.Body.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

const SubscriptionsList = props => {
  return (
    <>
      {props.subscriptions && props.subscriptions.length > 0 && (
        <SubscriptionsTable {...props} />
      )}
      <ButtonGroup alignEnd>
        <Button
          className="mt-8"
          onClick={() => props.editSubscription(newSubscription)}
          primary
        >
          {t('settings.tab.api_webhook.event_subscription.new_subscription')}
        </Button>
      </ButtonGroup>
    </>
  );
};

class NotificationSubscriptions extends Component {
  state = {
    currentSubscription: null,
    subscriptions: null,
    deleteModalIsVisible: false,
    deletableSubscriptionId: null,
    errors: null,
  };

  componentDidMount() {
    this.getSubscriptions();
  }

  editSubscription = subscription => {
    this.setState({ currentSubscription: subscription });
  };

  toggleDeleteModal = value => {
    this.setState({ deleteModalIsVisible: value });
  };

  setDeletableSubscriptionId = subscriptionId => {
    this.setState({ deletableSubscriptionId: subscriptionId });
  };

  onCancel = () => {
    this.editSubscription(null);
    this.getSubscriptions();
  };

  getSubscriptions() {
    const { subscriptionType } = this.props.meta;
    request
      .get(
        `${routes.NOTIFICATION_SUBSCRIPTIONS}?subscription_type=${subscriptionType}`,
      )
      .then(subscriptions => this.setState({ subscriptions }));
  }

  deleteSubscription = () => {
    request
      .delete(
        routes.NOTIFICATION_SUBSCRIPTION(this.state.deletableSubscriptionId),
      )
      .then(() => {
        this.setState({ deleteModalIsVisible: false });
        this.getSubscriptions();
      })
      .fail(failPayload => {
        this.setState({
          deleteModalIsVisible: false,
          errors: failPayload.responseJSON.errors,
        });
        this.getSubscriptions();
      });
  };

  render() {
    const { subscriptionType, events } = this.props.meta;
    const { currentSubscription, subscriptions, deleteModalIsVisible } =
      this.state;

    return (
      <>
        {deleteModalIsVisible && (
          <DeleteModal
            onDismiss={() => this.toggleDeleteModal(false)}
            onSubmit={this.deleteSubscription}
          />
        )}
        {this.state.errors && (
          <ErrorMessages
            errors={this.state.errors}
            onDismiss={() => this.setState({ errors: null })}
          />
        )}
        {currentSubscription ? (
          <SubscriptionForm
            onCancel={this.onCancel}
            events={events}
            subscriptionType={subscriptionType}
            subscription={currentSubscription}
          />
        ) : (
          <SubscriptionsList
            subscriptions={subscriptions}
            editSubscription={this.editSubscription}
            deleteSubscription={this.deleteSubscription}
            toggleDeleteModal={this.toggleDeleteModal}
            setDeletableSubscriptionId={this.setDeletableSubscriptionId}
          />
        )}
      </>
    );
  }
}

export default NotificationSubscriptions;
